<template>
<div class="wp-block-columns has-3-columns is-style-gutter immolisting">
  <div class="wp-block-column" v-for="item in items" :key="item.objectId">
    <a :href="item.link" :title="item.title + ' in ' + item.category">
    <div class="immolisting__wrapper">
        <div class="wp-block-columns immolisting__header">
            <div class="wp-block-column">
                <span class="fal fa-home"></span>
                {{ item.category }}
            </div>

            <div class="wp-block-column">
                <span v-html="item.price"></span>
            </div>
        </div>

        <div class="immolisting__image"
            :style="{backgroundImage: 'url(' + item.image + ')'}"></div>

        <h4>{{ item.title }}</h4>
        <p>in {{ item.zip }} {{ item.city }}</p>

        <div v-html="item.iconfields"></div>
    </div>
    </a>
  </div>
</div>
</template>

<script>
export default {
  name: 'ExposeList',

  props: [
    "items"
  ],

  created() {
  }
};
</script>
